import { useWSQuery } from "../../query/helpers";

type Query = ReturnType<typeof useWSQuery>;
export const useIsQueriesFetched = (...queries: [Query, ...Query[]]) => {
  return queries.every(query => query.isFetched);
};
